<template>
    <div v-if="!hide" class="position-relative widget my-4 py-4 px-5">
        <span
            class="position-absolute"
            style="cursor: pointer; top:1rem; right:1rem; z-index:1;"
            @click="hide = true"
        >
            <i class="fa fa-close "></i>
        </span>

        <h3>Welcome to goLOTUS</h3>

        <p>We have a <a href="/help">Help Center</a> to help you with setting up your system.</p>

        <p>If you have any questions see our <a href="/faq">Frequently Asked Questions</a> page.</p>

        <p>
            Still have questions then contact us!<br />
            Email: <a href="mailto:help@golotus.com">help@golotus.com</a><br />
        </p>
    </div>
</template>

<script>
export default {
    name: "WelcomeGolotusWidget",
    props: ["user"],
    data() {
        return {
            hide: false,
        };
    },
};
</script>

<style scoped>
a {
    color: dodgerblue;
}
</style>
